const routes = [
    {
      name: 'register',
      path: 'register/:token',
      component: () => import(/* webpackChunkName: "login" */ '@/view/forms/FormRegister.vue'),
    },
];

export default routes;